import { create } from 'zustand'
import { Page } from '@inertiajs/core'
import { SharedProps } from '@/lib/sharedProps'

export enum FlashNotificationType {
  Notice = 'notice',
  Alert = 'alert',
  Error = 'error',
}

export type FlashNotification = {
  id: string
  type: FlashNotificationType
  message: string
}

export type FlashNotificationStore = {
  notifications: FlashNotification[]
  addNotification: (notification: Omit<FlashNotification, 'id'>) => void
  addNotificationsFromPage: (page: Page<SharedProps>) => void
  removeNotification: (id: FlashNotification['id']) => void
}

export const useFlashNotificationStore = create<FlashNotificationStore>((set, get) => {
  let id = 0
  const getNextId = () => `${++id}`

  return {
    notifications: [],
    addNotification: notification => {
      set(state => ({
        notifications: [...state.notifications, { ...notification, id: getNextId() }],
      }))
    },
    addNotificationsFromPage: page => {
      if (!page.props.flash || typeof page.props.flash !== 'object') {
        return
      }

      const newNotifications = Object.values(FlashNotificationType)
        .map(type => ({ id: getNextId(), type, message: page.props.flash[type] }))
        .filter(({ message }) => typeof message === 'string' && message.trim() !== '')

      if (newNotifications.length) {
        set({ notifications: newNotifications })
      }
    },
    removeNotification: id => {
      set(state => ({
        notifications: state.notifications.filter(notification => notification.id !== id),
      }))
    },
  }
})
